import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { updateSection, setSection } from "../../../assignmentSlice";
import { getGradeAPI } from "../../../assignmentAPI";
import { getStartingIndex } from "../../../../../utils/resumeUtils";

import UserInputBar from "../../widgets/UserInputBar";
import CommonPage from "../../common/CommonPage";

const VocabularyPage = ({ setCurrentStep, isPreview, isReview }) => {
  const dispatch = useDispatch();
  const { section } = useSelector((state) => state.assignment);

  const [pageList, setPageList] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(-1);
  const [userInput, setUserInput] = useState("");
  const [overlayVisible, setOverlayVisible] = useState(false);
  const [isCorrect, setIsCorrect] = useState(false);

  const currentPage = pageList[currentIndex] || {
    type: "",
  };

  useEffect(() => {
    if (pageList.length > 0) return;

    if (!isPreview && section.answer.length > 0) {
      setPageList(section.answer);
      setCurrentIndex(getStartingIndex(section.resumeIndex));
      return;
    }
    setPageList(
      section.question.data.map((question) => {
        return {
          ...question,
          question: question.question.split(": ")[0],
          isSubmitted: false,
        };
      })
    );
    setCurrentIndex(0);
  }, [section]);

  useEffect(() => {
    if (currentPage.isSubmitted) {
      if (currentPage.isCorrect) {
        setUserInput(currentPage.input);
      } else {
        setUserInput(currentPage.answer);
      }
    } else {
      setUserInput("");
    }
  }, [currentIndex]);

  const handleChange = (e) => {
    setUserInput(e.target.value);
  };

  const handleSetAnswer = () => {
    const newPageList = pageList.map((page, pageIndex) => {
      if (pageIndex === currentIndex) {
        return {
          ...page,
          input: userInput,
        };
      }
      return page;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));
  };

  const handleNextPage = () => {
    if (currentIndex < pageList.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      let isAllAnswered = true;

      pageList.forEach((page, index) => {
        if (!page.isSubmitted) {
          isAllAnswered = false;
        }
      });

      if (isAllAnswered) {
        if (!isPreview && !isReview) {
          dispatch(
            updateSection({
              sectionId: section.id,
              data: { is_finished: true, answer: pageList },
            })
          );
        }
        alert("학습이 완료되었습니다.");
        setCurrentStep(2);
      } else {
        alert("문제를 덜 풀었습니다.");
      }
    }
  };

  const handlePreviousPage = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleSubmit = async () => {
    if (pageList[currentIndex]?.isSubmitted) return;
    if (userInput === "") {
      return alert("답을 입력해주세요.");
    }

    const grade = await getGradeAPI({
      data: {
        question: currentPage.question,
        input: userInput,
        answer: currentPage.answer,
      },
      type: "vocabulary",
    });

    setOverlayVisible(true);
    setIsCorrect(grade.is_correct === 1);

    const newPageList = pageList.map((page, pageIndex) => {
      if (pageIndex === currentIndex) {
        return {
          ...page,
          input: userInput,
          isCorrect: grade.is_correct === 1,
          isSubmitted: true,
        };
      }
      return page;
    });
    setPageList(newPageList);
    dispatch(setSection({ ...section, answer: newPageList }));

    setTimeout(() => {
      setOverlayVisible(false);
      if (grade.is_correct === 0) {
        setUserInput(currentPage.answer);
      } else {
        if (currentIndex < pageList.length - 1) {
          setTimeout(() => {
            setCurrentIndex(currentIndex + 1);
          }, 200);
        }
      }
    }, 600);
  };

  return (
    <CommonPage
      currentIndex={currentIndex}
      handleNextPage={handleNextPage}
      handlePreviousPage={handlePreviousPage}
      totalNo={pageList.length}
      currentPage={currentPage}
      paragraph={section?.question.full_text}
      overlayVisible={overlayVisible}
      isCorrect={isCorrect}
      handleSubmit={handleSubmit}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          gap: "50px",
          width: "90%",
        }}
      >
        <div
          style={{
            fontSize: "20px",
          }}
        >
          {"주어진 단어의 한글 뜻을 적으시오."}
        </div>
        <div
          style={{
            fontSize: "28px",
            textAlign: "center",
            lineHeight: "1.5",
          }}
        >
          {currentPage.question}
        </div>
        <div style={{ width: "60%", position: "relative" }}>
          <UserInputBar
            userInput={userInput}
            handleChange={handleChange}
            type={"comprehensive"}
            handleSetAnswer={handleSubmit}
            onlyUnderline={true}
            isSubmitted={currentPage.isSubmitted}
          />
        </div>
      </div>
    </CommonPage>
  );
};

export default VocabularyPage;
